<script setup>
import { onMounted, ref } from "vue";

import useNotification from "@/composables/notification";
import { usePage } from "@inertiajs/vue3";

const page = usePage();
const notification = useNotification();
const notificationSound = ref(null);

onMounted(() => {
  notification.check();

  if (page.props.user) {
    if (document.body.classList.contains("initialized")) {
      return;
    }

    window.Echo.private("users." + page.props.user.hashid).notification((e) => {
      try {
        if (notificationSound.value) {
          notificationSound.value?.pause();
          notificationSound.value?.play();
        }
      } catch (e) {
        console.error("Error playing notification sound:", e);
      }

      notification.unshift(e);
      notification.check();
    });

    document.body.classList.add("initialized");
  }
});
</script>

<template>
  <audio ref="notificationSound" src="/assets/audio/notification.mp3" preload="auto" class="invisible absolute"></audio>
</template>
